// SPDX-License-Identifier: AGPL-3.0-or-later

import {
	type AvatarDecorationCatalogEntryResponse,
	resolveAvatarDecorationLocalizedText,
} from '@fluxer/schema/src/domains/user/AvatarDecorationSchemas';

export function getAvatarDecorationDisplayName(
	entry: AvatarDecorationCatalogEntryResponse,
	locale: string | null | undefined,
): string {
	return resolveAvatarDecorationLocalizedText(locale, entry.name, entry.name_localizations);
}

export function getAvatarDecorationDisplayDescription(
	entry: AvatarDecorationCatalogEntryResponse,
	locale: string | null | undefined,
): string | undefined {
	if (!entry.description && !entry.description_localizations) {
		return undefined;
	}
	const resolved = resolveAvatarDecorationLocalizedText(
		locale,
		entry.description ?? '',
		entry.description_localizations,
	);
	return resolved || undefined;
}

export function getAvatarDecorationSearchHaystack(
	entry: AvatarDecorationCatalogEntryResponse,
	locale: string | null | undefined,
): string {
	const parts = [
		getAvatarDecorationDisplayName(entry, locale),
		getAvatarDecorationDisplayDescription(entry, locale) ?? '',
		entry.name,
		entry.description ?? '',
		...Object.values(entry.name_localizations ?? {}),
		...Object.values(entry.description_localizations ?? {}),
	];
	return parts.join(' ').toLowerCase();
}
